import type { EventData, EventOptions, Events } from '@coursera/event-pulse/sdk';
import { track } from '@coursera/event-pulse/sdk';

type TrackFn = <K extends keyof Events>(eventName: K, data: EventData<K>, options?: EventOptions<K>) => void;

// Hides `track`'s internal `client` parameter, and keeps a stable identity so it is safe in dependency arrays.
const trackEvent: TrackFn = (eventName, data, options) => track(eventName, data, options);

/**
 * This hook provides a function that can be used to track any event with any data and options.
 *
 * To track the same event with the same data every time, use `useBoundTracker` instead.
 */
function useTracker(): TrackFn {
  return trackEvent;
}

export type { EventData, EventOptions, Events, TrackFn };
export default useTracker;
